var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContainer = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 73,
  height: 66,
  viewBox: "0 0 73 66",
  fill: "none",
  id: "svg3",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "defs3"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 65H71.7368V15.72H1V40.36V65Z",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  id: "path1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.53 54.44H46.2008V1H12.53V27.688V54.44Z",
  fill: "white",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  id: "path2",
  style: {
    fill: "none"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.3464 23.5281V45.8641H61.0559V23.5281H46.2012H31.3464Z",
  fill: "#845EC2",
  id: "path3"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgContainer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/container.9f85577df31f4159a5d525d0109d7392.svg";